import { useState } from "react";
function useToggleState(defaultValue = false) {
    const [value, setValue] = useState(defaultValue);
    return [value, () => setValue(!value)];
}
export default useToggleState;
